<template>
  <div class="d-flex align-center">
    <ActionButton
      v-if="hasSelectedLines"
      icon="mdi-table-arrow-right"
      tooltip="Exporter"
      color="primary"
      @click="$emit('export')"
    />

    <ActionButton
      v-if="hasSelectedLines"
      icon="mdi-trash-can-outline"
      tooltip="Supprimer"
      color="error"
      @click="$emit('remove')"
    />

    <ActionButton
      icon="mdi-magnify"
      tooltip="Rechercher"
      color="info"
      @click="$emit('search')"
    />

    <ActionButton
      icon="mdi-refresh"
      tooltip="Recharger"
      color="warning"
      @click="$emit('reload')"
    />

    <ActionButton
      icon="mdi-printer"
      tooltip="Imprimer"
      color="secondary"
      @click="print"
    />

    <ActionButton
      icon="mdi-plus"
      :tooltip="`Créer ${attr}`"
      color="success"
      @click="$emit('add')"
    />
  </div>
</template>
<script setup lang="ts">
import ActionButton from "./ActionButton.vue";

defineProps<{
  attr?: string;
  hasSelectedLines?: boolean;
}>();

defineEmits<{
  (e: "reload"): void;
  (e: "search"): void;
  (e: "add"): void;
  (e: "remove"): void;
  (e: "export"): void;
}>();

const print = () => window.print();
</script>
